import { ANALYTICS_EVENTS } from '@/stores/analytics-events';
import { UserEventTracker } from '@/utils/analytics/tracking';

export class AuthEventTracker extends UserEventTracker {
  EVENT_NAMES = {
    SET_PASSWORD_INTERACTION: ANALYTICS_EVENTS.AUTH.SET_PASSWORD_INTERACTION,
    ACCOUNT_CREATION_SET_PASSWORD: ANALYTICS_EVENTS.AUTH.ACCOUNT_CREATION_SET_PASSWORD,
    PASSWORD_RESET_FAILED: ANALYTICS_EVENTS.AUTH.PASSWORD_RESET_FAILED,
    PASSWORD_RESET_SUCCESS: ANALYTICS_EVENTS.AUTH.PASSWORD_RESET_SUCCESS,
    LOGIN: ANALYTICS_EVENTS.AUTH.LOGIN,
    MFA_VERIFICATION: ANALYTICS_EVENTS.AUTH.MFA_VERIFICATION,
    MFA_VERIFICATION_FAILED: ANALYTICS_EVENTS.AUTH.MFA_VERIFICATION_FAILED,
    LOGGED_ON: ANALYTICS_EVENTS.AUTH.LOGGED_ON,
    LOGIN_FAILED: ANALYTICS_EVENTS.AUTH.LOGIN_FAILED,
    ACCOUNT_CREATED: ANALYTICS_EVENTS.AUTH.ACCOUNT_CREATION_ACCOUNT_CREATED,
    ONBOARDING_FLOW_QUESTIONS: ANALYTICS_EVENTS.AUTH.ONBOARDING_FLOW_QUESTIONS,
  };

  setPasswordInteraction(buttonClicked, linkUrl) {
    this.trackingStore.track(this.EVENT_NAMES.SET_PASSWORD_INTERACTION, { buttonClicked, linkUrl });
  }

  accountCreationSetPassword({
    method,
    successful,
    userId = null,
    brandId = null,
    brandName = null,
    customerStage = null,
    planType = null,
  }) {
    this.trackingStore.track(this.EVENT_NAMES.ACCOUNT_CREATION_SET_PASSWORD, {
      method,
      successful,
      $user_id: userId,
      brand_id: brandId,
      distinct_id: userId,
      brandName,
      customerStage,
      planType,
    });
  }

  passwordResetStatus({ success, email, message }) {
    const payload = success ? { email, message } : { email, error: message };
    const event = success
      ? this.EVENT_NAMES.PASSWORD_RESET_SUCCESS
      : this.EVENT_NAMES.PASSWORD_RESET_FAILED;
    this.trackingStore.track(event, payload);
  }

  login({ email, method, plgSetPassword }) {
    this.trackingStore.track(this.EVENT_NAMES.LOGIN, { email, method, plgSetPassword });
  }

  loggedOn({ method, enforcedLoginMethod }) {
    this.trackingStore.track(this.EVENT_NAMES.LOGGED_ON, { method, enforcedLoginMethod });
  }

  loginFailed({ email, error, method }) {
    this.trackingStore.track(this.EVENT_NAMES.LOGIN_FAILED, { email, error, method });
  }

  mfaVerification({ email, setup = false }) {
    this.trackingStore.track(this.EVENT_NAMES.MFA_VERIFICATION, { email, mfaSetup: setup });
  }

  mfaVerificationFailed({ email, error, setup = false }) {
    this.trackingStore.track(this.EVENT_NAMES.MFA_VERIFICATION_FAILED, {
      email,
      error,
      mfaSetup: setup,
    });
  }

  accountCreated({
    userId = null,
    brandId = null,
    brandName = null,
    customerStage = null,
    planType = null,
    page,
  }) {
    this.trackingStore.track(this.EVENT_NAMES.ACCOUNT_CREATED, {
      $user_id: userId,
      brand_id: brandId,
      distinct_id: userId,
      brandName,
      customerStage,
      planType,
      page,
    });
  }

  onboardingFlowQuestions({
    questionKey = null,
    questionResponse = null,
    teamInvites = null,
    platformConnectedStatusList = null,
    buttonText = null,
  }) {
    this.trackingStore.track(this.EVENT_NAMES.ONBOARDING_FLOW_QUESTIONS, {
      questionKey,
      questionResponse,
      teamInvites,
      platformConnectedStatusList,
      buttonText,
    });
  }
}
